var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46993_347906)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#FEF2DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_46993_347906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6806 7.05876L8.27059 12.941C8.02122 13.0875 7.94903 13.3063 7.95122 13.6235L7.97309 14.0194L20.0197 20.1969L32.0378 14.1178C32.0378 14.1178 32.0509 14.0566 32.0509 13.8422C32.0509 13.8422 32.04 13.56 31.9765 13.4288C31.9065 13.28 31.7578 13.1466 31.6615 13.0656C31.4056 12.8535 31.1497 12.6653 30.7143 12.4203C24.4734 8.89189 20.3697 7.07408 20.3697 7.07408C20.105 6.97564 19.8862 6.94064 19.6806 7.05876Z",
    fill: "#DEA66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13054 27.035C8.79554 27.4747 10.0096 28.0522 11.2368 28.7172C14.0893 30.2616 17.6943 32.1384 19.488 32.8756C19.7308 32.9762 19.8752 33.0244 20.0437 33.0331C20.1683 33.0397 20.374 32.9566 20.374 32.9566C20.374 32.9566 20.0393 20.8837 20.0196 20.1947C19.9999 19.5209 19.7177 19.2978 19.4683 19.1359C19.079 18.8866 18.2346 18.4972 18.2346 18.4972C18.2346 18.4972 15.2771 17.0272 12.324 15.4784C10.9196 14.7412 9.73397 13.9866 8.45866 13.3653C8.2246 13.2537 7.94897 13.3937 7.94897 13.6562V26.7375C7.94897 26.8622 8.02554 26.9672 8.13054 27.035Z",
    fill: "#B38251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7207 27.1114L20.3982 32.9498C20.2166 33.0439 20.0001 32.9126 20.0001 32.707L20.0198 20.1989C20.0198 20.0786 19.9826 19.8139 19.9454 19.7089C19.8426 19.4026 20.0657 19.2801 20.1663 19.2298L31.397 13.4461C31.6945 13.293 32.051 13.5095 32.051 13.8442V26.5733C32.051 26.7986 31.9241 27.0064 31.7207 27.1114Z",
    fill: "#966239"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.6633 16.4103C26.6633 16.4103 20.4574 19.5843 20.3567 19.8534C20.2561 20.1203 25.2261 17.7315 25.808 17.4318C26.4664 17.0928 31.6377 14.3278 31.6377 14.0237C31.6399 13.7743 26.6633 16.4103 26.6633 16.4103Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80225 26.311C9.60943 26.7179 10.4101 27.1379 11.4076 27.6476V27.2582C10.4144 26.7507 9.61162 26.3329 8.80225 25.9217V26.311ZM10.5019 26.4882C10.7294 26.6042 10.8432 26.6632 11.0576 26.7726C11.0597 26.0945 11.0597 25.7554 11.0619 25.0773C10.8476 24.9679 10.736 24.911 10.5107 24.7951C10.5063 25.4732 10.5041 25.8101 10.5019 26.4882ZM9.08881 25.762C9.27693 25.8582 9.38193 25.9129 9.59631 26.0223L9.60725 24.3335C9.39068 24.222 9.28568 24.1695 9.09537 24.0688C9.09318 24.747 9.091 25.086 9.08881 25.762Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1454 24.8103C10.6638 25.075 10.9394 25.2172 11.3966 25.4491C11.1691 25.0356 11.0444 24.8256 10.7951 24.4012C10.5391 24.5675 10.4057 24.6484 10.1454 24.8103ZM8.80225 24.1212C9.18943 24.3225 9.44975 24.4559 9.96162 24.7184C9.70787 24.2919 9.581 24.0797 9.34693 23.6619C9.1085 23.8347 8.99693 23.9244 8.80225 24.1212Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9584 28.1813C13.14 28.2753 13.2341 28.3256 13.4156 28.4197C13.4025 27.6147 13.3959 27.2122 13.3806 26.4072C13.2056 26.3153 13.1181 26.2694 12.9431 26.1797C12.9497 26.9803 12.9519 27.3806 12.9584 28.1813Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2913 28.0391C12.9563 28.3891 13.4725 28.6516 14.1113 28.9928C14.1069 28.7631 13.9297 28.4853 13.6891 28.3563C13.3128 28.1572 13.0985 28.0478 12.7178 27.8488C12.4728 27.7241 12.2913 27.8138 12.2913 28.0391ZM13.5578 25.7663L13.8378 26.3591C13.7503 26.545 13.7044 26.6391 13.6125 26.8228C13.6913 26.8163 13.7306 26.8141 13.8094 26.8075C13.9144 26.6675 13.9669 26.5975 14.0675 26.4575C13.9756 26.2409 13.9275 26.1316 13.8313 25.915C14.0981 26.0616 14.2294 26.1359 14.4722 26.2781C14.4722 27.0613 13.9603 27.4069 13.1903 27.0044C12.4203 26.6041 11.9106 25.7094 11.9106 24.9241C12.4838 25.2106 12.8688 25.3988 13.5578 25.7663Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0368 15.0758C27.9274 14.9948 16.1827 8.85889 16.1827 8.85889L12.5383 10.7423L24.5805 16.9526L24.5871 16.9592L28.1111 15.1545C28.1111 15.1545 28.1046 15.137 28.0849 15.1151C28.0696 15.102 28.0433 15.0823 28.0368 15.0758Z",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0937 15.1284C26.0987 16.1106 24.5806 16.9528 24.5806 16.9528C24.6309 17.0031 24.6331 17.0687 24.6331 17.1015C24.6265 17.3553 24.6221 17.5565 24.6156 17.8081C24.5849 19.1097 24.5674 20.4134 24.5237 21.715C24.6702 21.6275 24.8474 21.82 24.9809 21.715C25.1865 21.5531 25.624 20.84 25.6896 20.8181C25.7771 20.7897 25.8712 20.8115 25.9609 20.8072C26.3546 20.7853 27.2362 19.9825 27.4243 19.9453C27.6059 19.9103 28.2052 20.0262 28.2052 20.0262C28.2052 20.0262 28.1637 16.0559 28.1484 15.3887C28.144 15.1525 28.0937 15.1284 28.0937 15.1284Z",
    fill: "#BF9F85"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46993_347906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_46993_347906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1019,
    height: 26.0494,
    fill: "white",
    transform: "translate(7.94897 6.98413)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.8e99933d63c6eef824792e534d7f378e.svg";
export { ForwardRef as ReactComponent };